import { isNative } from './platform';

let Haptics = null;

async function getHaptics() {
  if (!isNative()) return null;
  if (Haptics) return Haptics;
  try {
    const mod = await import('@capacitor/haptics');
    Haptics = mod.Haptics;
    return Haptics;
  } catch {
    return null;
  }
}

export async function impactLight() {
  try {
    const h = await getHaptics();
    if (h) h.impact({ style: 'LIGHT' });
  } catch { /* ignore */ }
}

export async function impactMedium() {
  try {
    const h = await getHaptics();
    if (h) h.impact({ style: 'MEDIUM' });
  } catch { /* ignore */ }
}

export async function notificationSuccess() {
  try {
    const h = await getHaptics();
    if (h) h.notification({ type: 'SUCCESS' });
  } catch { /* ignore */ }
}

export async function impactHeavy() {
  try {
    const h = await getHaptics();
    if (h) h.impact({ style: 'HEAVY' });
  } catch { /* ignore */ }
}

export async function selectionChanged() {
  try {
    const h = await getHaptics();
    if (h) h.selectionChanged();
  } catch { /* ignore */ }
}
